<template>
  <div class="container" fluid>
    <b-modal id="deleteNews" title="DELETE NEW" @ok="DeleteNews">
      <div class="row">
        <div class="col">Do you want to delete this New ?</div>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "Delete New",

  data() {
    return {
      endpoint: "News",
    };
  },

  props: {
    newsExtracted: Number,
  },

  components: {},

  methods: {
    async DeleteNews() {
      this.$api.data.endpoint = this.endpoint;
      await this.$api.data.destroyById(this.newsExtracted);
      this.$emit("ok");
    },
  },
  mounted: function () {},
};
</script>


// WEBPACK FOOTER //
// src/components/News/NewsDelete.vue